import React from 'react';
import { useTheme } from '../context/ThemeContext';
import './ColorModeToggle.css';

const ColorModeToggle = () => {
    const { colorMode, toggleColorMode } = useTheme();
    const isDark = colorMode === 'dark';

    return (
        <button
            className="color-mode-toggle"
            onClick={toggleColorMode}
            aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
            title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        >
            <span className={`toggle-icon ${isDark ? 'moon' : 'sun'}`}>
                {isDark ? '🌙' : '☀️'}
            </span>
        </button>
    );
};

export default ColorModeToggle;
